module.exports = __webpack_public_path__ + "static/series_3500-2a8909eefef6ccfb52a166ccc69b7ae3.png";